import { useMemo } from 'react';

import { useAuth } from '../auth/AuthProvider';
import { decodeJwt, extractOrgId } from '../lib/jwt';

/**
 * Current org context (id + display name).
 *
 * `orgId` resolves from either the Keycloak `organization` claim or the
 * Robotics `formant:claims`. `orgName` prefers the session (Robotics fetches
 * it from the Formant API) and falls back to the Keycloak `organization` claim
 * alias on the token.
 */
export function useOrgContext(): { orgId: string | null; orgName: string | null } {
  const { token, orgName: sessionOrgName } = useAuth();
  return useMemo(() => {
    const claims = decodeJwt(token);
    const tokenOrgName = claims?.organization
      ? (Object.keys(claims.organization)[0] ?? null)
      : null;
    return { orgId: extractOrgId(claims), orgName: sessionOrgName ?? tokenOrgName };
  }, [token, sessionOrgName]);
}
